import { Users } from 'lucide-react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import type { PeriodOption } from '@repo/shared-dashboard';

interface MemberStatsWidgetProps {
  period?: PeriodOption;
}

const periodLabels: Record<PeriodOption, string> = {
  today: 'today',
  week: 'this week',
  month: 'this month',
  quarter: 'this quarter',
  year: 'this year',
};

export function MemberStatsWidget({ period = 'month' }: MemberStatsWidgetProps) {
  const query = useStaffDashboard(period);
  const periodText = periodLabels[period] ?? 'this period';

  return (
    <DataView query={query} isEmpty={() => false}>
      {(data) => {
        const hasPeriodCount = data?.newMembersCount !== undefined;
        const newCount = data?.newMembersCount ?? 0;
        return (
          <div className="bg-surface-1 rounded-[10px] p-5 flex items-center justify-between gap-4 transition-colors hover:bg-surface-2/50 h-full shadow-sm">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-accent-50 text-accent-500 rounded-[8px] border border-accent-200/50 flex-shrink-0">
                <Users className="w-6 h-6" />
              </div>
              <div>
                <div className="font-semibold text-3xl sm:text-4xl tnum text-text-primary leading-none">
                  {data?.membersCount ?? 0}
                </div>
                <div className="text-xs font-medium text-text-secondary uppercase tracking-wider mt-1.5">Total Members</div>
                {hasPeriodCount && (
                  <div className={`text-xs font-medium mt-1 ${newCount > 0 ? 'text-success-text' : 'text-text-muted'}`}>
                    {newCount > 0 ? `+${newCount}` : '0'} new {periodText}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </DataView>
  );
}

